/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('pnin_jql_order_by_rank_enabled_fg');
	},
};
